import arePropsEqual from 'react-fast-compare';
import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { ButtonWithAnalytics } from '../../../../components/Button/Button';
import { Local } from '../../../../components/Local/Local';
import { LinkWithAnalytics } from '../../../../components/Link/Link';
import { NAMESPACES } from '../../../../constants/namespaces';
import { GAME_LINK } from '../../../../constants/dataTestIds';
import { getGameDetailRoute } from '../../../../utils/routes';
import { getDataTestAttrs } from '../../../../utils/testing-locators';
import styles from './RandomGameCardContent.module.css';

const RandomGameCardContent = ({
  translationKey,
  id,
  additionalLayerData,
  eventActionPlay,
  index,
  sectionIndex,
  provider,
  routeState,
}) => {
  const history = useHistory();
  const clickHandler = useCallback(() => {
    history.push(getGameDetailRoute(id), routeState);
  }, [history, id, routeState]);

  return (
    <div className={styles.overlay}>
      <LinkWithAnalytics
        className={styles.title}
        to={{ pathname: getGameDetailRoute(id), state: routeState }}
        dataLayerEventData={{
          ...(additionalLayerData || {}),
          eventAction: eventActionPlay,
          game_id: id,
          position_index: index,
          section_index: sectionIndex,
          provider_id: provider,
        }}
        {...getDataTestAttrs(GAME_LINK)}
      >
        <Local namespace={NAMESPACES.GAME}>{translationKey}</Local>
      </LinkWithAnalytics>
      <ButtonWithAnalytics
        onClick={clickHandler}
        className={styles.play}
        dataLayerEventData={{
          ...(additionalLayerData || {}),
          eventAction: eventActionPlay,
          game_id: id,
          position_index: index,
          section_index: sectionIndex,
          provider_id: provider,
        }}
        {...getDataTestAttrs(GAME_LINK)}
      >
        <Local namespace={NAMESPACES.GAME}>Random play</Local>
      </ButtonWithAnalytics>
    </div>
  );
};

RandomGameCardContent.propTypes = {
  routeState: PropTypes.shape({}),
  eventActionPlay: PropTypes.string,
  eventActionPlayDemo: PropTypes.string,
  sectionIndex: PropTypes.number,
  index: PropTypes.number,
  additionalLayerData: PropTypes.shape({}),
  translationKey: PropTypes.string,
  id: PropTypes.string,
};

RandomGameCardContent.defaultProps = {
  routeState: {},
  additionalLayerData: {},
};
export default memo(RandomGameCardContent, arePropsEqual);
